import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const Container = ({ children, fullWidth, className, ...other }) => (
  <div
    className={classNames(
      'container',
      fullWidth && 'container--full-width',
      className
    )}
    {...other}
  >
    {children}
  </div>
);

Container.defaultProps = {
  className: null,
  fullWidth: false,
};

Container.propTypes = {
  /** A custom class name. */
  className: PropTypes.string,
  /** Prevent the narrow container on mobile and tablet */
  fullWidth: PropTypes.bool,
};

export default Container;
